export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE
};

export const basename = process.env.REACT_APP_BASENAME;

export const webApiConfig = {
  baseUri: {
    bff: process.env.REACT_APP_BFF_URL
  }
};
export const muiConfig = {
  license: process.env.REACT_APP_MUI_X_PRO_LICENSE
};

export const datadogConfig = {
  applicationId: '955a4fdf-71df-4559-bf30-663972c176ce',
  clientToken: 'pub5fb0c7fc33e18e21b53f66bc93b4337d',
  service: process.env.REACT_APP_DD_SERVICE,
  env: process.env.REACT_APP_DD_ENV,
  version: process.env.REACT_APP_DD_VERSION
};

export const isChunkTestEnabled =
  process.env.REACT_APP_ENABLE_CHUNK_TEST === 'true';

export const dcConfig = {
  identifier: process.env.REACT_APP_DC_IDENTIFIER,
  displayName: process.env.REACT_APP_DC_DISPLAY_NAME,
  theme: {
    primaryColor: process.env.REACT_APP_THEME_PRIMARY_COLOR,
    secondaryColor: process.env.REACT_APP_THEME_SECONDARY_COLOR
  }
};
